module.exports = __webpack_public_path__ + "Images/loader.gif";


//////////////////
// WEBPACK FOOTER
// ./Images/loader.gif
// module id = 1864
// module chunks = 2